import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'BrowserNotSupportedBanner.title',
    defaultMessage:
      '<b>Browser not supported.</b> For the best experience please use the latest version of <a>Chrome</a>',
  },
});
